<template>
  <div
    class="modal modal-flex fade"
    id="modal-add-pickup"
    tabindex="-1"
    role="dialog"
    aria-labelledby="flexModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <validation-observer tag="div" ref="validation" class="modal-content" v-slot="{ validate }">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            &times;
          </button>
          <h4 class="modal-title" id="flexModalLabel">Add Pickup</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <validation-provider rules="required" name="fire station" v-slot="{ errors, classes }">
              <div class="form-group" :class="classes">
                <label class="col-sm-4 control-label">Fire Station:</label>
                <div class="col-sm-8">
                  <multiselect
                    placeholder
                    preselect-first
                    :options="stations"
                    v-model="station"
                    track-by="id"
                    label="name"
                    :show-labels="false"
                  />
                </div>

                <help-block class="col-sm-offset-4 col-sm-8 help-block" v-bind="{ errors }"/>
              </div>
              <!-- /.form-group -->
            </validation-provider>

            <validation-provider name="number of bags" rules="required|min_value:1" v-slot="{ errors, classes }">
              <div class="form-group" :class="classes">
                <label class="col-sm-4 control-label">Number of bags:</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="bags" @focus="$event.target.select()"/>
                </div>

                <help-block class="col-sm-offset-4 col-sm-8 help-block" v-bind="{ errors }"/>
              </div>
              <!-- /.form-group -->
            </validation-provider>
          </div>
          <!-- /.form-horizontal -->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Cancel
          </button>
          <async-button type="button" class="btn btn-green" :click="addPickup" :validate="validate">
            Add Pickup
          </async-button>
        </div>
      </validation-observer>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import { http, handleServerErrors } from 'utils'
import { call, get } from 'vuex-pathify'
import BaseModal from 'components/BaseModal'

export default {
  extends: BaseModal,

  data () {
    return {
      station: null,
      bags: null
    }
  },

  computed: {
    ...get('stations', ['stations'])
  },

  methods: {
    ...call('stations', ['getStations']),

    async onModalShow () {
      this.$refs.validation.reset()

      await this.getStations()
    },

    onModalHidden () {
      this.station = null
      this.bags = null
    },

    async addPickup () {
      try {
        await http.post('pickup-requests', {
          station_id: this.station.id,
          bags: this.bags
        })

        this.$emit('added')

        this.hideModal()
      } catch (error) {
        if (!handleServerErrors(error, this.$refs.validation)) {
          this.$notify('error', 'Something went wrong when creating the pickup request.')
        }
      }
    }
  }
}
</script>
